const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.119048,0,0,0.119048,30,30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mastercard",
    transform: "matrix(1,0,0,1,-252,-252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504,252C504,335.2 436.8,403.2 352.8,403.2C269.6,403.2 201.6,335.2 201.6,252C201.6,168.8 268.8,100.8 352,100.8C436.8,100.8 504,168.8 504,252Z",
    style: {
      fill: "rgb(255,182,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.8,100.8C436,100.8 504,168.8 504,252C504,335.2 436.8,403.2 352.8,403.2C269.6,403.2 201.6,335.2 201.6,252",
    style: {
      fill: "rgb(247,152,29)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.8,100.8C436,100.8 504,168.8 504,252C504,335.2 436.8,403.2 352.8,403.2",
    style: {
      fill: "rgb(255,133,0)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.6,100.8C67.2,101.6 0,168.8 0,252C0,335.2 67.2,403.2 151.2,403.2C190.4,403.2 225.6,388 252.8,364C258.4,359.2 263.2,353.6 268,348L236.8,348C232.8,343.2 228.8,337.6 225.6,332.8L279.2,332.8C282.4,328 285.6,322.4 288,316.8L216.8,316.8C214.4,312 212,306.4 210.4,300.8L293.6,300.8C298.4,285.6 301.6,269.6 301.6,252.8C301.6,241.6 300,231.2 298.4,220.8L205.6,220.8C206.4,215.2 208,210.4 209.6,204.8L292.8,204.8C291.2,199.2 288.8,193.6 286.4,188.8L216,188.8C218.4,183.2 221.6,178.4 224.8,172.8L278.4,172.8C275.2,167.2 271.2,161.6 266.4,156.8L236.8,156.8C241.6,151.2 246.4,146.4 252,141.6C225.6,116.8 189.6,102.4 150.4,102.4C150.4,100.8 150.4,100.8 149.6,100.8Z",
    style: {
      fill: "rgb(255,80,80)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,252C0,335.2 67.2,403.2 151.2,403.2C190.4,403.2 225.6,388 252.8,364C258.4,359.2 263.2,353.6 268,348L236.8,348C232.8,343.2 228.8,337.6 225.6,332.8L279.2,332.8C282.4,328 285.6,322.4 288,316.8L216.8,316.8C214.4,312 212,306.4 210.4,300.8L293.6,300.8C298.4,285.6 301.6,269.6 301.6,252.8C301.6,241.6 300,231.2 298.4,220.8L205.6,220.8C206.4,215.2 208,210.4 209.6,204.8L292.8,204.8C291.2,199.2 288.8,193.6 286.4,188.8L216,188.8C218.4,183.2 221.6,178.4 224.8,172.8L278.4,172.8C275.2,167.2 271.2,161.6 266.4,156.8L236.8,156.8C241.6,151.2 246.4,146.4 252,141.6C225.6,116.8 189.6,102.4 150.4,102.4L149.6,102.4",
    style: {
      fill: "rgb(229,40,54)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.2,403.2C190.4,403.2 225.6,388 252.8,364C258.4,359.2 263.2,353.6 268,348L236.8,348C232.8,343.2 228.8,337.6 225.6,332.8L279.2,332.8C282.4,328 285.6,322.4 288,316.8L216.8,316.8C214.4,312 212,306.4 210.4,300.8L293.6,300.8C298.4,285.6 301.6,269.6 301.6,252.8C301.6,241.6 300,231.2 298.4,220.8L205.6,220.8C206.4,215.2 208,210.4 209.6,204.8L292.8,204.8C291.2,199.2 288.8,193.6 286.4,188.8L216,188.8C218.4,183.2 221.6,178.4 224.8,172.8L278.4,172.8C275.2,167.2 271.2,161.6 266.4,156.8L236.8,156.8C241.6,151.2 246.4,146.4 252,141.6C225.6,116.8 189.6,102.4 150.4,102.4L149.6,102.4",
    style: {
      fill: "rgb(203,32,38)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M204.8,290.4L207.2,276.8C206.4,276.8 204.8,277.6 203.2,277.6C197.6,277.6 196.8,274.4 197.6,272.8L202.4,244.8L211.2,244.8L213.6,229.6L205.6,229.6L207.2,220L191.2,220C191.2,220 181.6,272.8 181.6,279.2C181.6,288.8 187.2,292.8 194.4,292.8C199.2,292.8 203.2,291.2 204.8,290.4Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.4,264.8C210.4,287.2 225.6,292.8 238.4,292.8C250.4,292.8 255.2,290.4 255.2,290.4L258.4,275.2C258.4,275.2 249.6,279.2 241.6,279.2C224,279.2 227.2,266.4 227.2,266.4L260,266.4C260,266.4 262.4,256 262.4,252C262.4,241.6 256.8,228.8 239.2,228.8C222.4,227.2 210.4,244.8 210.4,264.8ZM238.4,241.6C247.2,241.6 245.6,252 245.6,252.8L228,252.8C228,252 229.6,241.6 238.4,241.6Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,290.4L343.2,272.8C343.2,272.8 335.2,276.8 329.6,276.8C318.4,276.8 313.6,268 313.6,258.4C313.6,239.2 323.2,228.8 334.4,228.8C342.4,228.8 348.8,233.6 348.8,233.6L351.2,216.8C351.2,216.8 341.6,212.8 332.8,212.8C314.4,212.8 296,228.8 296,259.2C296,279.2 305.6,292.8 324.8,292.8C331.2,292.8 340,290.4 340,290.4Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.8,227.2C105.6,227.2 97.6,230.4 97.6,230.4L95.2,244C95.2,244 102.4,240.8 112.8,240.8C118.4,240.8 123.2,241.6 123.2,246.4C123.2,249.6 122.4,250.4 122.4,250.4L115.2,250.4C101.6,250.4 86.4,256 86.4,274.4C86.4,288.8 96,292 101.6,292C112.8,292 117.6,284.8 118.4,284.8L117.6,291.2L132,291.2L138.4,247.2C138.4,228 122.4,227.2 116.8,227.2ZM120,263.2C120,265.6 118.4,278.4 108.8,278.4C104,278.4 102.4,274.4 102.4,272C102.4,268 104.8,262.4 116.8,262.4C119.2,263.2 120,263.2 120,263.2Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.6,292C157.6,292 177.6,292.8 177.6,271.2C177.6,251.2 158.4,255.2 158.4,247.2C158.4,243.2 161.6,241.6 167.2,241.6C169.6,241.6 178.4,242.4 178.4,242.4L180.8,228C180.8,228 175.2,226.4 165.6,226.4C153.6,226.4 141.6,231.2 141.6,247.2C141.6,265.6 161.6,264 161.6,271.2C161.6,276 156,276.8 152,276.8C144.8,276.8 137.6,274.4 137.6,274.4L135.2,288.8C136,290.4 140,292 153.6,292Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.8,214.4L469.6,236C469.6,236 463.2,228 454.4,228C440,228 427.2,245.6 427.2,266.4C427.2,279.2 433.6,292.8 447.2,292.8C456.8,292.8 462.4,286.4 462.4,286.4L461.6,292L477.6,292L489.6,215.2L472.8,214.4ZM465.6,256.8C465.6,265.6 461.6,276.8 452.8,276.8C447.2,276.8 444,272 444,264C444,251.2 449.6,243.2 456.8,243.2C462.4,243.2 465.6,247.2 465.6,256.8Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,291.2L39.2,233.6L40.8,291.2L52,291.2L72.8,233.6L64,291.2L80.8,291.2L93.6,214.4L67.2,214.4L51.2,261.6L50.4,214.4L27.2,214.4L14.4,291.2L29.6,291.2Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.6,291.2C282.4,264.8 283.2,243.2 294.4,247.2C296,236.8 298.4,232.8 300,228.8L296.8,228.8C289.6,228.8 284,238.4 284,238.4L285.6,229.6L270.4,229.6L260,292L277.6,292L277.6,291.2Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.8,227.2C365.6,227.2 357.6,230.4 357.6,230.4L355.2,244C355.2,244 362.4,240.8 372.8,240.8C378.4,240.8 383.2,241.6 383.2,246.4C383.2,249.6 382.4,250.4 382.4,250.4L375.2,250.4C361.6,250.4 346.4,256 346.4,274.4C346.4,288.8 356,292 361.6,292C372.8,292 377.6,284.8 378.4,284.8L377.6,291.2L392,291.2L398.4,247.2C399.2,228 382.4,227.2 376.8,227.2ZM380.8,263.2C380.8,265.6 379.2,278.4 369.6,278.4C364.8,278.4 363.2,274.4 363.2,272C363.2,268 365.6,262.4 377.6,262.4C380,263.2 380,263.2 380.8,263.2Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412,291.2C416.8,264.8 417.6,243.2 428.8,247.2C430.4,236.8 432.8,232.8 434.4,228.8L431.2,228.8C424,228.8 418.4,238.4 418.4,238.4L420,229.6L404.8,229.6L394.4,292L412,292L412,291.2Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M180,279.2C180,288.8 185.6,292.8 192.8,292.8C198.4,292.8 203.2,291.2 204.8,290.4L207.2,276.8C206.4,276.8 204.8,277.6 203.2,277.6C197.6,277.6 196.8,274.4 197.6,272.8L202.4,244.8L211.2,244.8L213.6,229.6L205.6,229.6L207.2,220",
    style: {
      fill: "rgb(220,229,229)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.4,264.8C218.4,287.2 225.6,292.8 238.4,292.8C250.4,292.8 255.2,290.4 255.2,290.4L258.4,275.2C258.4,275.2 249.6,279.2 241.6,279.2C224,279.2 227.2,266.4 227.2,266.4L260,266.4C260,266.4 262.4,256 262.4,252C262.4,241.6 256.8,228.8 239.2,228.8C222.4,227.2 218.4,244.8 218.4,264.8ZM238.4,241.6C247.2,241.6 248.8,252 248.8,252.8L228,252.8C228,252 229.6,241.6 238.4,241.6Z",
    style: {
      fill: "rgb(220,229,229)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340,290.4L343.2,272.8C343.2,272.8 335.2,276.8 329.6,276.8C318.4,276.8 313.6,268 313.6,258.4C313.6,239.2 323.2,228.8 334.4,228.8C342.4,228.8 348.8,233.6 348.8,233.6L351.2,216.8C351.2,216.8 341.6,212.8 332.8,212.8C314.4,212.8 304,228.8 304,259.2C304,279.2 305.6,292.8 324.8,292.8C331.2,292.8 340,290.4 340,290.4Z",
    style: {
      fill: "rgb(220,229,229)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.2,244.8C95.2,244.8 102.4,241.6 112.8,241.6C118.4,241.6 123.2,242.4 123.2,247.2C123.2,250.4 122.4,251.2 122.4,251.2L115.2,251.2C101.6,251.2 86.4,256.8 86.4,275.2C86.4,289.6 96,292.8 101.6,292.8C112.8,292.8 117.6,285.6 118.4,285.6L117.6,292L132,292L138.4,248C138.4,229.6 122.4,228.8 116,228.8M128,263.2C128,265.6 118.4,278.4 108.8,278.4C104,278.4 102.4,274.4 102.4,272C102.4,268 104.8,262.4 116.8,262.4C119.2,263.2 128,263.2 128,263.2Z",
    style: {
      fill: "rgb(220,229,229)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,290.4C136,290.4 140.8,292 154.4,292C158.4,292 178.4,292.8 178.4,271.2C178.4,251.2 159.2,255.2 159.2,247.2C159.2,243.2 162.4,241.6 168,241.6C170.4,241.6 179.2,242.4 179.2,242.4L181.6,228C181.6,228 176,226.4 166.4,226.4C154.4,226.4 150.4,231.2 150.4,247.2C150.4,265.6 162.4,264 162.4,271.2C162.4,276 156.8,276.8 152.8,276.8",
    style: {
      fill: "rgb(220,229,229)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.6,236C469.6,236 463.2,228 454.4,228C440,228 435.2,245.6 435.2,266.4C435.2,279.2 433.6,292.8 447.2,292.8C456.8,292.8 462.4,286.4 462.4,286.4L461.6,292L477.6,292L489.6,215.2M468.8,256.8C468.8,265.6 461.6,276.8 452.8,276.8C447.2,276.8 444,272 444,264C444,251.2 449.6,243.2 456.8,243.2C462.4,243.2 468.8,247.2 468.8,256.8Z",
    style: {
      fill: "rgb(220,229,229)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6,291.2L39.2,233.6L40.8,291.2L52,291.2L72.8,233.6L64,291.2L80.8,291.2L93.6,214.4L73.6,214.4L51.2,261.6L50.4,214.4L41.6,214.4L14.4,291.2L29.6,291.2Z",
    style: {
      fill: "rgb(220,229,229)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.8,291.2L277.6,291.2C282.4,264.8 283.2,243.2 294.4,247.2C296,236.8 298.4,232.8 300,228.8L296.8,228.8C289.6,228.8 284,238.4 284,238.4L285.6,229.6",
    style: {
      fill: "rgb(220,229,229)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.2,244.8C355.2,244.8 362.4,241.6 372.8,241.6C378.4,241.6 383.2,242.4 383.2,247.2C383.2,250.4 382.4,251.2 382.4,251.2L375.2,251.2C361.6,251.2 346.4,256.8 346.4,275.2C346.4,289.6 356,292.8 361.6,292.8C372.8,292.8 377.6,285.6 378.4,285.6L377.6,292L392,292L398.4,248C398.4,229.6 382.4,228.8 376,228.8M388,263.2C388,265.6 378.4,278.4 368.8,278.4C364,278.4 362.4,274.4 362.4,272C362.4,268 364.8,262.4 376.8,262.4C380,263.2 388,263.2 388,263.2Z",
    style: {
      fill: "rgb(220,229,229)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.2,291.2L412,291.2C416.8,264.8 417.6,243.2 428.8,247.2C430.4,236.8 432.8,232.8 434.4,228.8L431.2,228.8C424,228.8 418.4,238.4 418.4,238.4L420,229.6",
    style: {
      fill: "rgb(220,229,229)",
      fillRule: "nonzero"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.a0191eadc4e99e7ce3c7a9b38d811aa5.svg";
export { ForwardRef as ReactComponent };